"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarPickerItem = void 0;
var React = require("react");
var avatars_1 = require("../Avatar/avatars");
var TableRowIcon_1 = require("../TableRowIcon");
var AvatarPickerItem = function (props) {
    var avatar = props.avatar, isSelected = props.isSelected, onClick = props.onClick;
    return (React.createElement("span", { key: avatar, className: "avatar-icon" },
        isSelected && React.createElement(TableRowIcon_1.TableRowIcon, { circle: true, icon: "fa-check", className: "green" }),
        React.createElement("img", { src: (0, avatars_1.getAvatarUrl)(avatar), onClick: onClick })));
};
exports.AvatarPickerItem = AvatarPickerItem;
